export enum EnvironmentType {
  DEV = 'DEV',
  QA = 'QA',
  PROD = 'PROD',
}
